module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_f_melanistic.0ce31e3e.png";